import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, IconButton, InputAdornment, Card, FormControl, FormLabel, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import Moment from 'moment';
import * as FileSaver from 'file-saver';

// components
import AddIcon from "@mui/icons-material/Add";

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function EditServices() {
    const navigate = useNavigate();
    const location = useLocation();

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [pageSize, setPageSize] = useState(25);

    const userId = CurrentLoggedInUser.ExecutiveId;
    // const [editServiceData, setEditServiceData] = useState([]);
    const [searchServiceId, setSearchServiceId] = useState('');
    const [issueId, setIssueId] = useState("");
    const [serviceId, setServiceId] = useState("");
    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [site, setSite] = useState("");
    const [selectedSite, setSelectedSite] = useState([]);
    const [reportedBy, setReportedBy] = useState('');
    const [selectedReportedBy, setSelectedReportedBy] = useState([])
    const [effectiveFromValue, setEffectiveFromValue] = useState(null);
    const [effectiveToValue, setEffectiveToValue] = useState(null);
    const [editData, setEditData] = useState([]);
    const [filteredServiceData, setFilteredServiceData] = useState(editData);
    const [editLoadData, setEditLoadData] = useState([]);

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntrySiteName({ ClientId: "0" })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives()
            .then((response) => {
                setSelectedReportedBy(response.data);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);

    useEffect(() => {
        if (searchServiceId.trim() === '') {
            // No search → show full list
            setFilteredServiceData(editData);
        } else {
            const match = editData.find(
                (item) => String(item.ServiceId) === searchServiceId.trim()
            );
            setFilteredServiceData(match ? [match] : []);
        }
    }, [searchServiceId, editData]);

    const handleIssueId = (e) => {
        setIssueId(e.target.value);
    };
    const handleServiceId = (e) => {
        setServiceId(e.target.value);
    };
    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
    };
    const handleSite = (newValue) => {
        setSite(newValue?.SiteId || "");
    };

    const handleReportedBy = (newValue) => {
        setReportedBy(newValue?.Id || "");
    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);

    };

    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
    };

    const handleReset = () => {
        setClient("");
        setSite("");
        setReportedBy("");
        setIssueId("");
        setServiceId("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setEditData([]);

    };

    const handleClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;

                setEditLoadData(apiData);

                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };

    const exportToExcel = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "ReportedById",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "SubstatusId",
            "ProjectVersionId",
            "ReportedById",
            "ProjectId",
            "LastAllocatedById",
            "IssueCategoryId",
            "ActivityId",
            "ContactPersonId",
            "ExecutiveId",
            "ServiceTypeId",

        ];

        // Check if reports are available
        if (!filteredServiceData || filteredServiceData.length === 0) {
            enqueueSnackbar("No data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(filteredServiceData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );
        // Prepare the row data based on reports data
        const dataToExport = filteredServiceData.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                // Apply stripHtml if the value is a string
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `EditServiceListing_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Excel successfully.", { variant: "success" });
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "IssueId": Number(issueId) || 0,
            "ServiceId": Number(serviceId) || 0,
            "UserId": userId || 0,
            "ClientId": client || 0,
            "SiteId": site || 0,
            "ContactPersonId": reportedBy || 0,
            "FromDate": effectiveFromValue ? Moment(effectiveFromValue).format("DD/MMM/YYYY") : "",
            "ToDate": effectiveToValue ? Moment(effectiveToValue).format("DD/MMM/YYYY") : ""
        }
        console.log("filter payload", payload)
        URLS.editLoadServiceFilter(payload)
            .then((response) => {


                if (Array.isArray(response.data) && response.data[0]?.Error) {
                    setEditData([]);
                    setIsLoading(false);

                    enqueueSnackbar(response.data[0].Error, { variant: 'error' });
                } else {
                    setEditData(response.data);

                    console.log("+++++++++++++++", response.data)
                    setIsLoading(false);
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                }
            })
            .catch(error => {
                setEditData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);

            });
    };

    useEffect(() => {
        handleReset();
    }, [location.key]);

    return (
        <Page title="Edit Service| tiketic" >
            <StickyHeader
                title="Edit Service"
                showButton={false}

            />
            <ContentStyle>

                <Box sx={{
                    display: 'flex', gap: 2, height: '470px', px: 1.5,
                }}>
                    <Box sx={{ flex: 1, position: 'relative', display: 'flex' }}>
                        <Card sx={{ p: 2, height: '480px', borderRadius: '15px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                            {/* Header Row */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Box
                                        sx={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: '50%',
                                        }}
                                    />
                                    <Typography variant="h7">Service list</Typography>

                                    <Box
                                        sx={{
                                            width: '50px',
                                            height: '30px',
                                            borderRadius: '8px',
                                            boxShadow: '0px 0px 2px 0px #0000002E',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#666060',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: '#FFFFFF',
                                        }}
                                    >
                                        {editData?.length}
                                    </Box>
                                </Box>

                                <Box display="flex" alignItems="center" gap={1}>
                                    <TextField
                                        size="small"
                                        placeholder="Search By Service ID"
                                        value={searchServiceId}
                                        onChange={(e) => setSearchServiceId(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <ManageSearchOutlinedIcon sx={{ color: '#989898', width: 22, height: 22 }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            height: 35,
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#FFFFFF',
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                    <Tooltip title="Export To Excel" >

                                        <IconButton
                                            sx={{
                                                width: 38,
                                                height: 35,
                                                backgroundColor: "#FFFFFF",
                                                border: "1px solid #E0E0E0",
                                                borderRadius: "8px",
                                                color: '#ABABAB',
                                                "&:hover": {
                                                    backgroundColor: '#2E7D32', // primary color fill
                                                    color: "#fff",                                           // text white
                                                    borderColor: '1px solid #2E7D32',
                                                },
                                            }}
                                            onClick={exportToExcel}
                                        >
                                            <FileDownloadOutlinedIcon sx={{ width: 20, height: 20 }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>

                            {/* Scrollable Service Cards Section */}
                            {editData?.length > 0 ? (

                                <Box sx={{ height: '68vh', overflowY: 'auto' }}>
                                    <ServiceCards
                                        serviceData={filteredServiceData}
                                        handleClick={handleClick}
                                        variant="edit"
                                    />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        height: '68vh',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>
                                        No Data Found
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#928A8A', mt: 0.5 }}>
                                        Apply filters to view results
                                    </Typography>
                                </Box>
                            )}
                        </Card>
                    </Box>
                    <Box sx={{ width: '332px' }}>
                        <Card sx={{ p: 0, height: '480px', display: 'flex', flexDirection: 'column', border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                            <Box sx={{ p: 2, borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography variant="h6">Filter</Typography>
                            </Box>
                            <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1 }}>
                                <Stack spacing={2}>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Issue ID</FormLabel>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={issueId}
                                            onChange={handleIssueId}
                                            type="number"
                                            placeholder="Issue Id"

                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Service ID</FormLabel>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={serviceId}
                                            onChange={handleServiceId}
                                            type="number"
                                            placeholder="Service Id"

                                        />
                                    </FormControl>

                                    <FormControl fullWidth size="small">
                                        <FormLabel > Client</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={[{ Id: 0, Name: "Select" }, ...selectedClient]}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder={
                                                        client.length === 0 ? "Select Option" : ""
                                                    }
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth >
                                        <FormLabel >Site </FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="site"
                                            value={selectedSite.find((option) => option.SiteId === site) || ""}
                                            options={[{ Id: 0, Name: "Select" }, ...selectedSite]}

                                            onChange={(_, newValue) => handleSite(newValue)}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder={
                                                        site.length === 0 ? "Select Option" : ""
                                                    }
                                                />
                                            )}
                                            limitTags={2}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.SiteId}>
                                                    {option.Name}
                                                </li>
                                            )}

                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth >
                                        <FormLabel >Reported By </FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="reported"
                                            value={selectedReportedBy.find((option) => option.Id === reportedBy) || ""}
                                            onChange={(_, newValue) => handleReportedBy(newValue)}
                                            options={[{ Id: 0, Name: "Select" }, ...selectedReportedBy]}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder={
                                                        reportedBy.length === 0 ? "Select Option" : ""
                                                    }
                                                />
                                            )}

                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel >From Date</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveFromValue ? Moment(effectiveFromValue, 'DD-MMM-YYYY').toDate() : null}
                                                onChange={handleEffFrom}
                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel >To Date</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker

                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveToValue ? Moment(effectiveToValue, 'DD-MMM-YYYY').toDate() : null}
                                                onChange={handleEffTo}
                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>


                                </Stack>
                            </Box>
                            <Box sx={{ py: 1, px: 2, borderTop: '1px solid #E5E5E5' }}>
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    <Tooltip title="Reset">

                                        <Button variant="outlined" sx={{ width: '145px', height: '42px', color: '#374151' }} onClick={handleReset}>Reset</Button>
                                    </Tooltip >

                                    <Tooltip title="Filter">
                                        <Button variant="contained" sx={{ width: '145px', height: '42px' }} onClick={onFilterClick}>Apply</Button>
                                    </Tooltip >
                                </Stack>
                            </Box>

                        </Card>
                    </Box>

                </Box>
            </ContentStyle>
            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}

        </Page>
    );
}

